module.exports = __webpack_public_path__ + "static/media/place.c8e4ba7f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/place.svg
// module id = 115
// module chunks = 0